import { render, staticRenderFns } from "./MeetingBotSettings.vue?vue&type=template&id=4a46857d&scoped=true&"
import script from "./MeetingBotSettings.vue?vue&type=script&lang=js&"
export * from "./MeetingBotSettings.vue?vue&type=script&lang=js&"
import style0 from "./MeetingBotSettings.vue?vue&type=style&index=0&id=4a46857d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46857d",
  null
  
)

export default component.exports